import css from "../Form.module.css";

const SubHeader = ({ children }) => {
  return (
    <div className={css.SubHeader}>
      <h4>{children.label}</h4>
    </div>
  );
};

export default SubHeader;
